"use strict";
/**
 * @module Services.TopicUpdate
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var json_patch_result_1 = require("./json-patch-result");
/**
 * Serialiser for {@link JsonPatchResult}
 */
var JsonPatchResultSerialiserClass = /** @class */ (function (_super) {
    __extends(JsonPatchResultSerialiserClass, _super);
    function JsonPatchResultSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link JsonPatchResult} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link JsonPatchResult} that was read
     */
    JsonPatchResultSerialiserClass.prototype.read = function (bis) {
        var failedOperation = Codec.readInt32(bis);
        return new json_patch_result_1.JsonPatchResult(failedOperation);
    };
    return JsonPatchResultSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.JsonPatchResultSerialiserClass = JsonPatchResultSerialiserClass;
/**
 * The {@link JsonPatchResultSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.JsonPatchResultSerialiser = new JsonPatchResultSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/json-patch-result-serialiser.js
// module id = 1422
// module chunks = 1